import { apiClient } from './api';

// 연봉 이력 타입 정의
export interface SalaryHistory {
  id: number;
  employeeId: number;
  year: number;
  annualSalary: number;
  memo?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertSalaryDto {
  year: number;
  annualSalary: number;
  memo?: string;
}

export const salaryHistoryApi = {
  // 직원의 연봉 이력 조회
  getByEmployee: (employeeId: number): Promise<SalaryHistory[]> => {
    return apiClient.get<SalaryHistory[]>(`/employees/${employeeId}/salary-history`);
  },

  // 특정 연도 연봉 조회
  getByYear: (employeeId: number, year: number): Promise<SalaryHistory | null> => {
    return apiClient.get<SalaryHistory | null>(`/employees/${employeeId}/salary-history/${year}`);
  },

  // 연봉 저장 (생성 또는 수정)
  upsert: (employeeId: number, dto: UpsertSalaryDto): Promise<SalaryHistory> => {
    return apiClient.post<SalaryHistory>(`/employees/${employeeId}/salary-history`, dto);
  },

  // 연봉 이력 삭제
  delete: (employeeId: number, year: number): Promise<{ message: string }> => {
    return apiClient.delete<{ message: string }>(`/employees/${employeeId}/salary-history/${year}`);
  },

  // 여러 연도 연봉 일괄 저장
  bulkUpsert: (
    employeeId: number,
    salaries: UpsertSalaryDto[],
  ): Promise<SalaryHistory[]> => {
    return apiClient.post<SalaryHistory[]>(`/employees/${employeeId}/salary-history/bulk`, {
      salaries,
    });
  },
};
